import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
  IconButton,
  useTheme
} from '@mui/material';
import { Lock, Close } from '@mui/icons-material';

interface TrialExpiredDialogProps {
  open: boolean;
  onClose: () => void;
  onLearnMore: () => void;
}

const TrialExpiredDialog: React.FC<TrialExpiredDialogProps> = ({ 
  open, 
  onClose,
  onLearnMore
}) => {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          borderRadius: '16px',
          background: theme.palette.mode === 'dark' ? 'rgba(17, 17, 17, 0.98)' : '#FFFFFF',
          border: theme.palette.mode === 'dark' ? '1px solid rgba(255, 255, 255, 0.1)' : '1px solid rgba(0, 0, 0, 0.1)',
          boxShadow: theme.palette.mode === 'dark' 
            ? '0 0 30px rgba(0, 0, 0, 0.8)' 
            : '0 0 30px rgba(0, 0, 0, 0.15)',
        }
      }}
    >
      <DialogTitle sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between',
        pb: 1
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box sx={{ 
            width: 40, 
            height: 40, 
            borderRadius: '8px', 
            backgroundColor: '#FEF3C7',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#F59E0B'
          }}>
            <Lock sx={{ fontSize: 24 }} />
          </Box>
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
            Trial Expired
          </Typography>
        </Box>
        <IconButton onClick={onClose} size="small">
          <Close />
        </IconButton>
      </DialogTitle>
      
      <DialogContent>
        <Typography variant="body1" sx={{ 
          color: theme.palette.mode === 'dark' ? '#F1F5F9' : '#374151',
          mb: 2,
          lineHeight: 1.5
        }}>
          Your trial period has expired and the guided walkthrough is no longer available. 
          To continue using OpenANA Security's advanced features including the interactive tour, 
          please upgrade your account.
        </Typography>
        
        <Typography variant="body2" sx={{ 
          color: theme.palette.mode === 'dark' ? '#CBD5E1' : '#6B7280',
          lineHeight: 1.5
        }}>
           Click on learn more
        </Typography>
      </DialogContent>
      
      <DialogActions sx={{ p: 3, pt: 1 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{ mr: 1 }}
        >
          Close
        </Button>
        <Button
          onClick={onLearnMore}
          variant="contained"
          sx={{
            backgroundColor: '#FF4405',
            color: 'white',
            '&:hover': {
              backgroundColor: '#E63E04'
            }
          }}
        >
          Learn More
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TrialExpiredDialog;